import { render, staticRenderFns } from "./glosasCargadasAA.vue?vue&type=template&id=d78b9dce&scoped=true&"
import script from "./glosasCargadasAA.vue?vue&type=script&lang=js&"
export * from "./glosasCargadasAA.vue?vue&type=script&lang=js&"
import style0 from "./glosasCargadasAA.vue?vue&type=style&index=0&id=d78b9dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78b9dce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
